var presentClearpay = presentClearpay || {};
var cpConfig = cpConfig || {};
var installmentConfig = Drupal.settings.installment_price;

(function($) {
  Drupal.behaviors.productInstallmentPriceUKV1 = {
    clearpayLibrary: installmentConfig.clearpay_lib,
    priceSelector: '.price_installment',
    locale: installmentConfig.locale,
    currency: installmentConfig.currency,
    min: installmentConfig.min_value,
    max: installmentConfig.max_value,
    logoColor: installmentConfig.clearpay_logo_color,

    attach: function(context) {
      var self = this;
      if (self.attached) {
        return;
      }
      self.attached = true;
      self.setup(context);
    },

    setup: function(context) {
      var self = this;
      var imported = document.createElement('script');
      imported.src = self.clearpayLibrary;
      document.head.appendChild(imported);
      if (!imported.readyState) {
        imported.onload = function() {
          self.initClearPay(context);
        };
      }
    },

    initClearPay: function(context) {
      var self = this;
      var amount = null;
      presentClearpay.clearpayConfig = function(amount) {
        var $afterpayContent = $('.afterpay-paragraph');
        if ($afterpayContent.length > 0) {
          $afterpayContent.remove();
        }
        cpConfig = {
          priceSelector: self.priceSelector,
          locale: self.locale,
          currency: self.currency,
          showUpperLimit: false,
          amount: amount,
          clearpayLogoColor: self.logoColor,
          minMaxThreshold: {
            min: self.min,
            max: self.max,
          },
        };
        new presentClearpay(cpConfig).init();
      };
      var $productPrice = $('.product-sku-price .js-sku-price', context);
      if ($productPrice.length > 0) {
        amount = $($productPrice).html() || $productPrice.html() || '';
      }
      if (amount) {
        amount = amount.replace('£', '').replace('.', '');
        presentClearpay.clearpayConfig(amount);
      }
    },

    attached: false,
  };
})(jQuery);
